module.exports = "/images/delete-icon.svg?26b6460a6407d87bcc88d80af6838e61";